export const CM_CONTENT = {
  hero: {
    kicker: 'Para empresas que formalizam serviços, obras ou vendas recorrentes',
    title: 'Quantos contratos da sua empresa ainda são feitos copiando um Word antigo e torcendo para não esquecer nada?',
    subtitle:
      'Gere contratos automaticamente a partir da proposta comercial aprovada, envie para assinatura eletrônica e saiba na hora quando o cliente assinou.',
    cta: 'Quero automatizar meus contratos',
    ctaMessage: 'Quero conhecer o sistema de gestão de contratos do 77Gestão',
    urgency: 'Cada contrato manual é um risco jurídico e uma chance de erro que pode custar caro depois.',
  },

  statsStrip: [
    { number: 'Automático', label: 'preenchimento das variáveis do contrato', icon: 'fa-solid fa-file-signature' },
    { number: '100%', label: 'digital, da proposta à assinatura', icon: 'fa-solid fa-signature' },
    { number: 'Tempo real', label: 'confirmação de assinatura do cliente', icon: 'fa-solid fa-envelope-circle-check' },
  ],

  pain: {
    title: 'Se seus contratos ainda passam por isso, o risco é maior do que parece',
    intro:
      'Empresas que formalizam serviços, obras ou vendas recorrentes perdem tempo e correm risco jurídico quando o contrato depende de um processo manual.',
    items: [
      { icon: 'fa-solid fa-file-word', text: 'Contrato feito manualmente no Word toda vez, copiando o modelo anterior e torcendo para não esquecer de trocar um dado.' },
      { icon: 'fa-solid fa-magnifying-glass', text: 'Sem controle de quem já assinou e quem ainda está devendo retorno — só descoberto ligando para o cliente.' },
      { icon: 'fa-solid fa-scale-balanced', text: 'Risco jurídico real por falta de padronização entre os contratos emitidos pela empresa.' },
      { icon: 'fa-solid fa-paper-plane', text: 'Envio de contrato por e-mail sem confirmação de recebimento ou de assinatura.' },
      { icon: 'fa-regular fa-clock', text: 'Tempo perdido revisando cláusula por cláusula para garantir que nenhum dado do cliente ficou errado.' },
    ],
  },

  midCta: {
    text: 'E se o contrato saísse pronto, revisado e assinado sem você precisar abrir o Word?',
    cta: 'Quero ver como funciona',
    ctaMessage: 'Quero ver uma demonstração do sistema de gestão de contratos do 77Gestão',
  },

  solution: {
    title: 'Do modelo à assinatura, sem sair do sistema',
    intro:
      'O módulo de contratos do 77Gestão conecta sua proposta comercial aprovada à geração do contrato e ao envio para assinatura eletrônica.',
    cards: [
      {
        icon: 'fa-solid fa-file-lines',
        title: 'Modelos de contrato reutilizáveis',
        text: 'Crie modelos com variáveis dinâmicas — nome da empresa, CNPJ, cliente, valor e outras informações preenchidas automaticamente.',
      },
      {
        icon: 'fa-solid fa-arrow-right-arrow-left',
        title: 'Geração a partir da proposta aprovada',
        text: 'Assim que uma proposta comercial é aprovada, o contrato é gerado automaticamente com os dados já preenchidos.',
      },
      {
        icon: 'fa-solid fa-file-signature',
        title: 'Envio para assinatura eletrônica',
        text: 'O contrato é enviado direto para assinatura eletrônica através da integração com o DocuSeal, sem precisar sair do sistema.',
      },
      {
        icon: 'fa-solid fa-circle-check',
        title: 'Confirmação automática por webhook',
        text: 'Assim que o cliente assina, o sistema recebe a confirmação automaticamente e atualiza o status do contrato.',
      },
      {
        icon: 'fa-solid fa-envelope',
        title: 'Notificação por e-mail',
        text: 'Você é avisado por e-mail assim que o contrato é assinado, sem precisar ficar checando manualmente.',
      },
    ],
  },

  proof: {
    title: 'O que muda quando o contrato deixa de depender do Word',
    intro:
      'Uma empresa que formalizava contratos manualmente perdia horas por semana revisando dados e não sabia dizer, sem procurar em e-mails, quais clientes já tinham assinado.',
    stats: [
      { number: '0', label: 'contratos com dado errado por copiar e colar' },
      { number: '100%', label: 'de rastreabilidade de quem assinou' },
      { number: 'Minutos', label: 'para gerar um contrato a partir da proposta' },
    ],
    paragraphs: [
      'Depois de configurar os modelos de contrato com variáveis dinâmicas, a geração do documento passou a ser automática a partir da proposta comercial aprovada.',
      'O envio para assinatura eletrônica e a confirmação automática por webhook eliminaram a dúvida sobre quem já tinha assinado — e o risco de um contrato sair com dado errado.',
    ],
    highlight: 'Resultado: contratos padronizados, assinatura rastreável e menos risco jurídico.',
    cta: 'Quero esse controle nos meus contratos',
    ctaMessage: 'Vi o resultado e quero automatizar os contratos da minha empresa com o 77Gestão',
  },

  benefits: {
    title: 'Os três pilares da gestão de contratos',
    items: [
      {
        icon: 'fa-solid fa-eye',
        title: 'Visibilidade',
        text: 'Saiba o status de cada contrato — gerado, enviado ou assinado — sem precisar perguntar para ninguém.',
      },
      {
        icon: 'fa-solid fa-sliders',
        title: 'Controle',
        text: 'Modelos padronizados com variáveis preenchidas automaticamente eliminam erro de digitação e inconsistência jurídica.',
      },
      {
        icon: 'fa-solid fa-binoculars',
        title: 'Previsibilidade',
        text: 'Confirmação automática de assinatura permite planejar os próximos passos sem esperar retorno manual do cliente.',
      },
    ],
  },

  differentials: {
    title: 'Por que empresas escolhem o 77Gestão para gerir contratos',
    items: [
      { icon: 'fa-solid fa-puzzle-piece', text: 'Contrato gerado a partir da proposta comercial já aprovada — sem digitar tudo de novo.' },
      { icon: 'fa-solid fa-handshake', text: 'Implantação acompanhada para montar seus modelos de contrato com as variáveis certas desde o início.' },
      { icon: 'fa-solid fa-headset', text: 'Suporte humano, próximo e muito bem avaliado, para tirar dúvida sobre qualquer contrato.' },
      { icon: 'fa-solid fa-link', text: 'Assinatura eletrônica integrada via DocuSeal, com confirmação automática direto no sistema.' },
    ],
  },

  faq: {
    title: 'Perguntas comuns antes de começar',
    items: [
      {
        question: 'Preciso de outro sistema para assinatura eletrônica?',
        answer:
          'Não. O 77Gestão já envia o contrato para assinatura eletrônica através da integração com o DocuSeal, direto do sistema, sem precisar de uma ferramenta separada.',
      },
      {
        question: 'Como o sistema sabe que o cliente assinou?',
        answer:
          'Assim que a assinatura é concluída, o DocuSeal envia uma confirmação automática por webhook para o 77Gestão, que atualiza o status do contrato e dispara uma notificação por e-mail.',
      },
      {
        question: 'Consigo usar meus próprios modelos de contrato?',
        answer:
          'Sim. Você cadastra seus modelos com as variáveis dinâmicas que sua empresa usa — nome da empresa, CNPJ, cliente, valor e outras — e o sistema preenche tudo automaticamente a cada novo contrato.',
      },
      {
        question: 'O contrato é gerado automaticamente ou preciso montar cada um manualmente?',
        answer:
          'A partir de uma proposta comercial aprovada, o contrato é gerado automaticamente com os dados já preenchidos, restando apenas revisar antes de enviar para assinatura.',
      },
      {
        question: 'Minha empresa tem poucos contratos por mês, vale a pena?',
        answer:
          'Vale. Mesmo com poucos contratos, padronizar o processo reduz risco jurídico e evita retrabalho. E o controle de quem já assinou economiza tempo desde o primeiro contrato.',
      },
    ],
  },

  ctaFinal: {
    title: 'Pare de fazer contrato no Word e torcer para não errar nenhum dado.',
    subtitle:
      'Agende uma demonstração e veja como gerar e assinar contratos direto do sistema, com confirmação automática.',
    cta: 'Agendar demonstração agora',
    ctaMessage: 'Quero agendar uma demonstração do sistema de gestão de contratos do 77Gestão',
  },

  seo: {
    title: 'Sistema de Gestão de Contratos | 77Gestão',
    description:
      'Sistema de gestão de contratos com modelos automáticos e assinatura eletrônica via DocuSeal. Gere, envie e confirme contratos assinados sem sair do sistema.',
  },
};
